export const authConstants = {
  AUTH_LOGIN: 'AUTH_LOGIN',
  AUTH_LOGOUT: 'AUTH_LOGOUT',
  AUTH_UPDATE_USER: 'AUTH_UPDATE_USER',
}
